/**
 * Convert ISO datetime string to display format
 * @param dateTimeString - ISO datetime string (e.g., "2025-09-15T17:38:30.649Z")
 * @returns Formatted datetime string (e.g., "2025-09-15 17:38:30")
 */
export const convertDateTimeFormat = (dateTimeString: string): string => {
  if (!dateTimeString) {
    return '';
  }

  try {
    const date = new Date(dateTimeString);

    // Check if date is valid
    if (Number.isNaN(date.getTime())) {
      return '';
    }

    // Format to YYYY-MM-DD HH:mm:ss
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } catch (error) {
    console.error('Error formatting datetime:', error);
    return '';
  }
};

/**
 * Get today's date in YYYY-MM-DD format (local timezone).
 */
export const getTodayDateString = (): string => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
